import type { SVGProps } from "react";
const SenecPictogramRouter = (props: Pick<SVGProps<SVGSVGElement>, "color">) => (
    <svg width={48} height={48} viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" role="img" {...props}>
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M38.9487 13.3163C39.1233 12.7923 38.8402 12.226 38.3162 12.0513C37.7923 11.8767 37.226 12.1599 37.0513 12.6838L33.2792 24H14.7208L10.9487 12.6838C10.774 12.1599 10.2077 11.8767 9.68377 12.0513C9.15983 12.226 8.87667 12.7923 9.05132 13.3163L12.6126 24H9.5C8.11929 24 7 25.1193 7 26.5V28C7 28.5523 7.44772 29 8 29C8.55228 29 9 28.5523 9 28V26.5C9 26.2239 9.22386 26 9.5 26H13.9766C13.9921 26.0004 14.0076 26.0004 14.0231 26H33.9769C33.9924 26.0004 34.0079 26.0004 34.0234 26H38.5C38.7761 26 39 26.2239 39 26.5V33.5C39 33.7762 38.7761 34 38.5 34H9.5C9.22386 34 9 33.7762 9 33.5V33C9 32.4477 8.55228 32 8 32C7.44772 32 7 32.4477 7 33V33.5C7 34.8807 8.11929 36 9.5 36H10V39H15.618L17.118 36H30.882L32.382 39H38V36H38.5C39.8807 36 41 34.8807 41 33.5V26.5C41 25.1193 39.8807 24 38.5 24H35.3874L38.9487 13.3163ZM36 36H33.118L33.618 37H36V36ZM12 37V36H14.882L14.382 37H12Z"
            fill="currentColor"
        />
        <path
            d="M12.5 31.5C13.3284 31.5 14 30.8285 14 30C14 29.1716 13.3284 28.5 12.5 28.5C11.6716 28.5 11 29.1716 11 30C11 30.8285 11.6716 31.5 12.5 31.5Z"
            fill="currentColor"
        />
        <path
            d="M19 30C19 30.8285 18.3284 31.5 17.5 31.5C16.6716 31.5 16 30.8285 16 30C16 29.1716 16.6716 28.5 17.5 28.5C18.3284 28.5 19 29.1716 19 30Z"
            fill="currentColor"
        />
        <path
            d="M26 29C25.4477 29 25 29.4477 25 30C25 30.5523 25.4477 31 26 31H36C36.5523 31 37 30.5523 37 30C37 29.4477 36.5523 29 36 29H26Z"
            fill="currentColor"
        />
    </svg>
);
export default SenecPictogramRouter;
